// src/components/common/SearchFilterBar.jsx
//Changed
import React, { useMemo, useState } from "react";

export default function SearchFilterBar({
  q,
  onChangeQ,
  onSearch,
  searchField,
  onChangeSearchField,
  placeholder = "검색어를 입력해 주세요.",
  // 검색 옵션 커스터마이징용
  searchFieldOptions,

  // 날짜 필터
  dateFilter,
  onChangeDateFilter,
  startDate,
  endDate,
  onDateChange,

  // 페이지네이션
  pageSize,
  onChangePageSize,

  leftExtra = null,
  rightExtra = null,
  size = "md",
}) {
  const sizeMap = {
    sm: "px-2 py-1.5 text-sm",
    md: "px-3 py-2 text-sm",
    lg: "px-4 py-2.5 text-base",
  };
  const cls = sizeMap[size] || sizeMap.md;

  const today = useMemo(() => new Date(), []);

  // 검색 옵션: 미지정 시 기본(제목/작성자/DNS)
  const fieldOptions =
    searchFieldOptions && searchFieldOptions.length
      ? searchFieldOptions
      : [
          { value: "title", label: "제목" },
          { value: "author", label: "작성자" },
          { value: "dns", label: "DNS" },
        ];

  const calcDateRange = (months) => {
    const end = today.toISOString().slice(0, 10);

    const d = new Date();
    d.setMonth(d.getMonth() - months);
    const start = d.toISOString().slice(0, 10);

    return { start, end };
  };

  // 날짜 옵션 변경 시 자동계산
  const handleDateFilterChange = (v) => {
    onChangeDateFilter(v);

    if (v === "6m") onDateChange(calcDateRange(6));
    else if (v === "3m") onDateChange(calcDateRange(3));
    else if (v === "1m") onDateChange(calcDateRange(1));
    else if (v === "all") onDateChange({ start: "", end: "" });

    onSearch(); //Changed: 자동 검색
  };

  // 날짜 변경 시 유효성 검사 + 자동검색
  const updateStartDate = (value) => {
    if (endDate && new Date(value) > new Date(endDate)) {
      alert("시작일은 종료일보다 이후일 수 없습니다.");
      return;
    }
    onDateChange({ start: value, end: endDate });
    onSearch();
  };

  const updateEndDate = (value) => {
    if (startDate && new Date(value) < new Date(startDate)) {
      alert("종료일은 시작일보다 이전일 수 없습니다.");
      return;
    }
    onDateChange({ start: startDate, end: value });
    onSearch();
  };

  return (
    <div className="flex items-center justify-between gap-3 flex-wrap">
      {/* 왼쪽 */}
      <div className="flex items-center gap-2 flex-wrap">
        {leftExtra}

        {/* 검색 옵션 */}
        {/* 날짜 필터 */}
        <div className="flex items-center gap-2 flex-wrap">
          <select
            className={`rounded-lg border ${cls}`}
            value={dateFilter}
            onChange={(e) => handleDateFilterChange(e.target.value)}
          >
            <option value="all">작성일 전체</option>
            <option value="6m">6개월 이내</option>
            <option value="3m">3개월 이내</option>
            <option value="1m">1개월 이내</option>
            <option value="custom">기간 직접 선택</option>
          </select>

          {dateFilter === "custom" && (
            <div className="flex items-center gap-1">
              {/* 시작일 */}
              <input
                type="date"
                className={`rounded-lg border ${cls}`}
                value={startDate || ""}
                onChange={(e) => updateStartDate(e.target.value)}
              />
              <span className="text-gray-500">~</span>

              {/* 종료일 */}
              <input
                type="date"
                className={`rounded-lg border ${cls}`}
                value={endDate || ""}
                onChange={(e) => updateEndDate(e.target.value)}
              />
            </div>
          )}

          {rightExtra}
        </div>

        {/* 페이지 사이즈 */}
        <select
          className={`rounded-lg border ${cls}`}
          value={pageSize}
          onChange={(e) => {
            onChangePageSize(Number(e.target.value));
            onSearch();
          }}
        >
          <option value={15}>15건 조회</option>
          <option value={30}>30건 조회</option>
          <option value={50}>50건 조회</option>
          <option value={100}>100건 조회</option>
        </select>

        {/* 검색 옵션 */}
        <select
          className={`rounded-lg border ${cls}`}
          value={searchField}
          onChange={(e) => {
            onChangeSearchField(e.target.value);
            onSearch();
          }}
        >
          {fieldOptions.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>

        {/* 검색어 */}
        <input
          className={`rounded-lg border w-48 ${cls}`}
          placeholder={placeholder}
          value={q}
          onChange={(e) => {
            onChangeQ(e.target.value);
          }}
          onKeyDown={(e) => e.key === "Enter" && onSearch()} // 엔터 검색
        />

        {/* 검색 버튼 */}
        <button
          onClick={onSearch}
          className={`btn-search`}
        >
          검색
        </button>

        <button
          onClick={() => {
            onChangeQ(""); // 검색어 초기화
            const defaultField =
              (fieldOptions && fieldOptions[0]?.value) || "title";
            onChangeSearchField(defaultField); // 검색필드 초기화
            onChangeDateFilter("all"); // 날짜옵션 초기화
            onDateChange({ start: "", end: "" }); // 날짜값 초기화
            onChangePageSize(15);
            onSearch(); // 변경 즉시 검색
          }}
          className={"btn-cancel"}
        >
          초기화
        </button>
      </div>
    </div>
  );
}
